import React, { forwardRef } from "react";
import "./Card.css";

export const Card = forwardRef(function Card(
  { padded = true, hover = false, accent = false, className = "", children, ...props },
  ref
) {
  const classes = [
    "ui-card",
    padded ? "ui-card-padded" : "",
    hover ? "ui-card-hover" : "",
    accent ? "ui-card-accent" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div ref={ref} className={classes} {...props}>
      {children}
    </div>
  );
});

export function CardHeader({ title, eyebrow, action, children, className = "", ...props }) {
  return (
    <div className={`ui-card-header ${className}`} {...props}>
      <div className="ui-card-header-text">
        {eyebrow && <span className="ui-card-eyebrow">{eyebrow}</span>}
        {title && <h3 className="ui-card-title">{title}</h3>}
        {children}
      </div>
      {action && <div className="ui-card-header-action">{action}</div>}
    </div>
  );
}

export function CardBody({ children, className = "", ...props }) {
  return <div className={`ui-card-body ${className}`} {...props}>{children}</div>;
}

export function CardFooter({ children, className = "", ...props }) {
  return <div className={`ui-card-footer ${className}`} {...props}>{children}</div>;
}
